import "./index.css";
import "./App.css";
import PagesRoute from "./routes/pagesRoute";
import { Header } from "./components/headerSection/header";
import { useEffect, useState, useMemo } from "react";
import { useDispatch } from "react-redux";
import { getAllProductsData } from "./features/productSlice";
import { Wishlist } from "./components/wishlistSection";
import { Cart } from "./components/cartSection";

import { ToastProvider } from "./context/ToastContext";
import { fetchIsTokenValid } from "./features/authSlice/fetchIsTokenValid";
import { getUserData } from "./features/authSlice";
import { HelmetProvider } from 'react-helmet-async';
import { useLocation } from "react-router-dom";
import WelcomeModal from "./components/welcomeModal/WelcomeModal";

import { SocketProvider } from './context/SocketContext';
import { useSocket } from './context/SocketContext'; 
import { addProduct, updateProduct, removeProduct } from "./features/productSlice";

// Separate component to handle socket logic inside provider
const SocketListener = () => {
    const socket = useSocket();
    const dispatch = useDispatch();

    useEffect(() => {
        if (socket) {
            socket.on("product:new", (newProduct) => {
                dispatch(addProduct(newProduct));
            });

            socket.on("product:update", (updatedProduct) => {
                dispatch(updateProduct(updatedProduct));
            });

            socket.on("product:delete", (deletedId) => {
                dispatch(removeProduct(deletedId));
            });
        }
    
        return () => {
            if (socket) {
                socket.off("product:new");
                socket.off("product:update");
                socket.off("product:delete");
            }
        }
      }, [socket, dispatch]);

      return null;
}

function App() {
  const [isLargeScreen, setIsLargeScreen] = useState("");
  const [isWishlistActive, setIsWishlistActive] = useState(false);
  const [isCartSectionActive, setIsCartSectionActive] = useState(false);

  // ... (hooks)
  const location = useLocation();
  const isAdminRoute = useMemo(() => {
    return location.pathname.startsWith("/admin");
  }, [location.pathname]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchIsTokenValid());
  }, [dispatch]);

  useEffect(() => {
    dispatch(
      getUserData(JSON.parse(localStorage.getItem("UserData")) || "")
    );
  }, [dispatch]);

  useEffect(() => {
    dispatch(getAllProductsData());
  }, []);

  useEffect(() => {
    const updateScreen = () => {
      setIsLargeScreen(window.innerWidth >= 768);
    };

    updateScreen();
    window.addEventListener("resize", updateScreen);
    return () => window.removeEventListener("resize", updateScreen);
  }, []);

  return (
    <HelmetProvider>
    <SocketProvider>
    <ToastProvider> 
    <SocketListener />
    <div className="App-container lg:text-[18px]">

      {/* Show PUBLIC HEADER only when NOT on admin pages */}
      {!isAdminRoute && (
        <>
          <Header
            {...{
              setIsWishlistActive,
              setIsCartSectionActive,
              isLargeScreen,
            }}
          />
          <Wishlist
            {...{ isWishlistActive, setIsWishlistActive }}
          />
          <Cart
            {...{ isCartSectionActive, setIsCartSectionActive }}
          />
        </>
      )}

      {!isAdminRoute && <WelcomeModal />}

      {/* Render app content */}
      <PagesRoute {...{ setIsCartSectionActive }} />

    </div>
    </ToastProvider>
    </SocketProvider>
    </HelmetProvider>
  );
}

export default App;
